import { render, staticRenderFns } from "./StaffScheduleTab.vue?vue&type=template&id=4de68786&"
import script from "./StaffScheduleTab.vue?vue&type=script&lang=js&"
export * from "./StaffScheduleTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4de68786')) {
      api.createRecord('4de68786', component.options)
    } else {
      api.reload('4de68786', component.options)
    }
    module.hot.accept("./StaffScheduleTab.vue?vue&type=template&id=4de68786&", function () {
      api.rerender('4de68786', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/branches/Tabs/StaffScheduleTab.vue"
export default component.exports